import { init } from "../bindings/Translation2";

let datatmp;
datatmp = require("./Datatmp.json");
export { datatmp };

const unitsT = {};
const traitsT = {};
const itemsT = {};

for (let [unitId, unit] of Object.entries(datatmp.units)) {
  unitsT[`${unitId}`] = unit.name;
  unitsT[`${unitId}_ability`] = unit.ability.name;
  unitsT[`${unitId}_desc`] = unit.ability.desc;
  // unit.ability.botUi.forEach((v, idx) => {
  //   unitsT[`${unitId}_details_${idx}`] = v;
  // });
}

for (let [traitId, trait] of Object.entries(datatmp.traits)) {
  traitsT[`${traitId}`] = trait.name;
  traitsT[`${traitId}_desc`] = trait.desc;
}

// for (let [itemId, item] of Object.entries(datatmp.items)) {
//   itemsT[`${itemId}`] = item.name;
//   if (item.desc) {
//     itemsT[`${itemId}_desc`] = item.desc;
//   }
// }

init({}, unitsT, traitsT, itemsT, {}, {});

export const makeAugId = (name) => {
  return name
    .replace(/[\+-]/gm, "")
    .replace("'", "")
    .replace(/\s/gm, "_")
    .toLowerCase();
};
